var app = angular.module('leonardo');

var ReportsWorkFlowList = function($scope, $state, $controller, $filter, ReportService, ApprovalStepService, FilterService) {

  $controller('ReportsBaseController', {$scope: $scope});

  $scope.workflowExpanded = null;
  $scope.sequenceExpanded = null;
  $scope.by_unit = $state.current.by_unit;

  if ($scope.by_unit) {
    $scope.title = $filter('translate')('Unit Workflow Reports');
  }
  else {
    $scope.title = $filter('translate')('Workflow Reports');
  }

  $scope.report_type = $scope.by_unit ? ReportService.TYPE_UNIT : ReportService.TYPE_WORKFLOW;

  $scope.workflowIsExpanded = function(workflow) {
    return ($scope.workflowExpanded === workflow);
  };

  $scope.toggleWorkflow = function(workflow) {
    $scope.workflowExpanded = ($scope.workflowExpanded === workflow) ? null : workflow;
  };

  $scope.approvalSequenceIsExpanded = function(sequence) {
    return ($scope.sequenceExpanded === sequence);
  };

  $scope.toggleApprovalSequence= function(sequence) {
    $scope.sequenceExpanded = ($scope.sequenceExpanded === sequence) ? null : sequence;
  };

  $scope.groupReports = function (data) {
    $scope.unit_report_type = FilterService.getFilter('unit_report_type');
    if (data.results) {
      $scope.reports = data.results.data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }

    transformAttachmentUrls($scope.reports);

    $scope.reportsGrouped = [];

    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({ id: account.id, name: account.name });
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({ id: portfolio.id, name: portfolio.name });
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({ id: property.id, name: property.name });
          }
        });
        break;
    }
    angular.forEach($scope.reports, function (value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              updateworkFlowGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.property && value.property.groups && (value.property.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.property.groups, function (group) {
              updateworkFlowGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.portfolio && value.portfolio.groups && (value.portfolio.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.portfolio.groups, function (group) {
              updateworkFlowGroupCase(group, id, name, array_by_name);
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({ id: id, name: name });
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)) {
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({ id: manager.id, name: manager.name });
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({ id: value.managed_by.id, name: value.managed_by.name });
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({ id: id, name: name });
          }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({ id: value_manager.id, name: value_manager.name, workflows: [] });
          }
          if (getIndexArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].workflows, value.id) < 0) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].workflows.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({ id: id, name: name, workflows: [] });
        }
        if (getIndexArray($scope.reportsGrouped[$scope.getIndex(id)].workflows, value.id) < 0) {
          $scope.reportsGrouped[$scope.getIndex(id)].workflows.push(value);
        }
      }
    });

    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
  };

  function updateworkFlowGroupCase(group, id, name, array_by_name) {
    if (FilterService.hasFilter('group_reports')) {
      if (_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())) {
        id.push(group.id);
        name.push(group.name);
        array_by_name.push({ id: group.id, name: group.name });
      }
    } else {
      id.push(group.id);
      name.push(group.name);
      array_by_name.push({ id: group.id, name: group.name });
    }
  }

  $scope.getActionItemName = function(workflow) {
    if (workflow.action_items && workflow.action_items.length > 0) {
      return workflow.action_items[0].name;
    }
    return null;
  };

  $scope.getDays = function(action_item) {
    if (!action_item.start) {
      return 0;
    }
    if (!action_item.finish) {
      return moment().diff(moment(action_item.start), 'days');
    }
    return moment(action_item.finish).diff(moment(action_item.start), 'days');
  };

  $scope.getTotalDays = function(action_items) {
    var totalDays = 0;
    var today = moment();
    for (var i = 0; i < action_items.length; i++) {
      if (!action_items[i].start) {
        totalDays += 0;
      }
      else if (!action_items[i].finish) {
        totalDays += moment(today).diff(moment(action_items[i].start), 'days') ?
          moment(today).diff(moment(action_items[i].start), 'days') : 1;
      }
      else {
        totalDays += moment(action_items[i].finish).diff(moment(action_items[i].start), 'days') ?
          moment(action_items[i].finish).diff(moment(action_items[i].start), 'days') : 1;
      }
    }
    return totalDays;
  };

  $scope.getApprovalStatus = function(status) {
    let nameStatus = '';
    angular.forEach(ApprovalStepService.STATUS_TYPES, function (state) {
      if(state.id == status ){
        nameStatus = state.name;
      }
    });
    return nameStatus
  };

  $scope.getTasksList = function(workflow) {
    let html = '';
    workflow.action_items.map(ai => ai.id).forEach(function(value){
      html += '<p>'+value+'</p>';
    });
    return html;
  };

  function transformAttachmentUrls(reports) {
    angular.forEach(reports, function(workflow) {
      if (workflow.action_items) {
        angular.forEach(workflow.action_items, function(action_item) {
          if (action_item.notes) {
            angular.forEach(action_item.notes, function(note) {
              if (note.attachments) {
                angular.forEach(note.attachments, function(attachment) {
                  if (attachment.document_file) {
                    attachment.file = attachment.document_file.signed_view_url;
                  } else if (attachment.signed_view_url) {
                    attachment.file = attachment.signed_view_url;
                  } else if (attachment.link) {
                    attachment.file = attachment.link;
                  }
                });
              }
            });
          }
        });
      }
    });
  }

};

app.controller('ReportsWorkFlowList', ['$scope', '$state', '$controller', '$filter', 'ReportService', 'ApprovalStepService', 'FilterService', ReportsWorkFlowList]);
